var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Figma"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Taobao"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path0_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M0 15C0 6.71575 6.71575 0 15 0C23.2843 0 30 6.71575 30 15C30 23.2843 23.2843 30 15 30C6.71575 30 0 23.2843 0 15Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M12 24C13.6569 24 15 22.6569 15 21V18H12C10.3431 18 9 19.3431 9 21C9 22.6569 10.3431 24 12 24Z",
    fill: "#0ACF83"
  }))), /*#__PURE__*/React.createElement("g", {
    id: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "path2_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M9 15C9 13.3431 10.3431 12 12 12H15V18H12C10.3431 18 9 16.6569 9 15Z",
    fill: "#A259FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "path2_fill-link_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2_fill_2",
    d: "M9 9C9 7.34315 10.3431 6 12 6H15V12H12C10.3431 12 9 10.6569 9 9Z",
    fill: "#F24E1E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M15 6H18C19.6569 6 21 7.34315 21 9C21 10.6569 19.6569 12 18 12H15V6Z",
    fill: "#FF7262"
  }))), /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    d: "M21 15C21 16.6569 19.6569 18 18 18C16.3431 18 15 16.6569 15 15C15 13.3431 16.3431 12 18 12C19.6569 12 21 13.3431 21 15Z",
    fill: "#1ABCFE"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp3);
export default __webpack_public_path__ + "static/media/app3.30fd8028386889979af79fd9e19115b6.svg";
export { ForwardRef as ReactComponent };